/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { toast } from "react-toastify";
import LOGO from "../assets/LOGO.svg";
import Form from "../components/Form";
import Timer from "../components/Timer";
import WalletPopup from "../components/walletpopup";
import ProgressBar from "../components/ProgressBar";
import {Link} from "react-router-dom";

toast.configure();
const Swap = ({
  account,
  bnbBalance,
  buy,
  icoPrice,
  totalSupply,
  tokenSold,
  userTokenBalance,
  icoPriceFormated,
  loadWeb3,
  startTime,
  endTime,
  days,
  hours,
  minutes,
  seconds,
  difference,
  loadWalleConnect,
  fundsRaised,
  iWeb3,
  chainId,
  contract,
  CONNECTABLE_CHAINID,
}) => {
  const [walletOpen, setWalletOpen] = useState(false);
  return (
    <div className=" pb-10 px-4">
      <div className=" max-w-6xl mx-auto">
        <div className=" flex justify-between items-center gap-4 py-8">
          <button className=" blue-gradient btn px-6 text-xs flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white">
            <a href="https://bscscan.com/address/0x8dD0F468A4Dd7ECBd0DD451D6FBfC5a321b13752" target="_blank" rel="noreferrer">
              CONTRACT
            </a>
          </button>
          <img src={LOGO} className="hidden md:block max-w-[250px]" alt="" />
          <button
            className=" orange-gradient btn px-6 text-xs flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white"
            onClick={() => setWalletOpen((prev) => !prev)}
          >
            {account
              ? account.slice(0, 8) + "..." + account.slice(account.length - 5)
              : "CONNECT WALLET"}
          </button>
        </div>

        <div className="mt-10 flex justify-center items-center">
          <Link
              to="/"
              className="orange-gradient btn px-6 text-sm flex justify-center items-center sm:text-base text-center sm:px-10 py-1.5 font-bold text-white"
          >
            GO BACK
          </Link>
        </div>

        <div className="mt-20">
          <Timer
            days={days}
            hours={hours}
            minutes={minutes}
            seconds={seconds}
            startTime={startTime}
            endTime={endTime}
            difference={difference}
          />
        </div>
        <div className=" max-w-2xl mx-auto w-full">
          {/*<ProgressBar
            totalSupply={totalSupply}
            fundsRaised={fundsRaised}
            tokenSold={tokenSold}
            iWeb3={iWeb3}
            account={account}
          />*/}
        </div>

        <div className="  max-w-2xl mx-auto w-full">
          <Form
            icoPrice={icoPrice}
            account={account}
            buy={buy}
            bnbBalance={bnbBalance}
            userTokenBalance={userTokenBalance}
            loadWeb3={loadWeb3}
            loadWalleConnect={loadWalleConnect}
            startTime={startTime}
            endTime={endTime}
            icoPriceFormated={icoPriceFormated}
            iWeb3={iWeb3}
            chainId={chainId}
            contract={contract}
            CONNECTABLE_CHAINID={CONNECTABLE_CHAINID}
          />
        </div>
        <WalletPopup
          open={walletOpen}
          onClose={setWalletOpen}
          title={account ? "Disconnect Wallet" : "Select a Wallet"}
          text={
            account
              ? "Are you sure you want to disconnect?"
              : "Please select a wallet to connect to this dapp:"
          }
          metaMaskHandler={loadWeb3}
          account={account}
          loadWalleConnect={loadWalleConnect}
        />
      </div>
    </div>
  );
};

export default Swap;
